var map = {
	"./desktop/en/HitechZone.json": 89409,
	"./desktop/en/RailNinja.json": 89208,
	"./mobile/en/HitechZone.json": 20517,
	"./mobile/en/RailNinja.json": 45204,
	"./server/en/HitechZone.json": 13204,
	"./server/en/RailNinja.json": 30555
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 27104;